 
<template>
  <el-container class="examine">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList='searchList' :rightEventList="rightEventList" @rightFunc='rightFunc'
        v-on:getSearchObj='getSearchObj'>
      </publicExpandSearch>
    </div> 
    <el-main class="content" style="padding-top: 0px;">
      <div class="content-list">
        <BaseTable :data="pageData.records" :optimize='true'
          :header-cell-style="{background:'#FAFAFA',color:'#333333',fontWeight:'bold'}" tooltip-effect="dark"
          :column="tableConfig" pagination :auto-scroll="true" :total="pageData.total" :page.sync="searchParams.current"
          :limit.sync="searchParams.size" @pagination="getPackagePage">
        </BaseTable>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { packagePage, packageStatus } from "./api/index.js";
export default {
  data() {
    return {
      breadList: [{ name: "推送管理" }, { name: "计划管理" }],
      searchList: [],
      searchParams: {
        current: 1,
        size: 10
      },
      rightEventList: [{ eventName: "+ 新建计划", eventValue: 1 }],
      pageData: {},
      addform: {},
      //病种码
      tableConfig: [
        {
          label: "序号",
          align: "center",
          size: "mini",
          type: "index"
        },
        {
          label: "计划名称",
          align: "center",
          prop: "planName",
          size: "mini"
        },
        {
          label: "计划说明",
          align: "center",
          prop: "planDescribe",
          size: "mini"
        },
        {
          label: "最后修改时间",
          align: "center",
          prop: "updateTime",
          size: "mini", 
        },
        {
          label: "引用情况",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.recordStatus ? "启用" : "停用"}
              </span>
            );
          }
        },
        {
          label: "修改人",
          align: "center",
          prop: "updateUser",
          size: "mini",
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.edit(scope.row);
                    }
                  }
                },
                "修改"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.changeStatus(scope.row);
                    }
                  }
                }, 
                scope.row.recordStatus != 1 ? "启用" : "停用"
              )
            ]);
          }
        }
      ]
    };
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.searchList.push(
        {
          label: "计划名称",
          paramName: "planName",
          inputType: "input",
          default: "",
        }
      )
    }, 1)
  },
  methods: {
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.getPackagePage();
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.$router.push({
          path: "/pushManagement/component/addPlan",
          query: { edit: 1 }
        });
      }
    },
    //列表数据
    getPackagePage() {
      packagePage(this.searchParams).then(res => {
        if (res.data == null) {
          this.pageData = [];
        } else {
          this.pageData = res.data;
        }
      });
    },
    //修改
    edit(row, index) {
      this.$router.push({
        path: "/pushManagement/component/addPlan",
        query: {
          id: row.id,
          edit: 2,
          linkSttaus: row.linkSttaus
        }
      });
    },
    //启用|禁用
    changeStatus(row, index) {
      packageStatus({
        enable: row.recordStatus == 1 ? false : true,
        id: row.id
      }).then(res => {
        this.$message.success("成功");
        if (row.recordStatus == 1) {
          row.recordStatus = 0;
        } else {
          row.recordStatus = 1;
        }
      });
    },
    sizeChange(e) {
      this.searchParams.size = e;
      this.getPackagePage();
    },
    currentChange(e) {
      this.searchParams.current = e;
      this.getPackagePage();
    }
  }
};
</script>
<style lang="less" scoped>
.examine {
  height: 100%;
  width: 100%;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  .content {
    // height: 88vh;
    // width: 100%;
    padding: 10px;
    .content-list {
      background: #fff;
      border-radius: 5px;
      //   height: 100%;
      //   width: 100%;
      padding: 15px;
    }
  }
}
.input-r {
  margin-right: 20px;
}

/deep/.el-tabs__header {
  margin: 0;
}

/deep/.el-tabs__nav-wrap::after {
  background: #fff;
}

/deep/.el-tabs__item {
  padding: 0 35px;
}

/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
}

/deep/.el-table__header-wrapper {
  background-color: #fafafa;
}

/deep/.el-table th > .cell {
  color: #333;
  font-weight: bold;
}

/deep/.el-table th {
  background: #fafafa;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #1a7bfc;
}
.selece-w {
  width: 80%;
}
/deep/.el-dialog--center .el-dialog__body {
  padding-bottom: 0;
}
</style>
